// --------------------------------------------------------------
// Created On: 2025-11-06
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Attempt to load initial state from local storage.
const localStorageQuantity = localStorage.getItem("reduxCartQuantity");
let initialState = 0;
if (localStorageQuantity !== null && !Number.isNaN(parseInt(localStorageQuantity, 10))) {
  initialState = parseInt(localStorageQuantity, 10);
}

// A Redux slice for the quantity of parts in the shopping cart.
const cartQuantitySlice = createSlice({
  name: "cartQuantity",
  initialState,
  reducers: {
    setCartQuantity: (state, action: PayloadAction<number>) => {
      localStorage.setItem("reduxCartQuantity", `${action.payload}`);
      return action.payload;
    },
  },
});

export const { setCartQuantity } = cartQuantitySlice.actions;
export default cartQuantitySlice.reducer;
